// src/components/ErrorBoundary.jsx
// If something in a page breaks while it is drawn, show a way out instead of a blank screen, and report it.
import React from 'react';
import { reportError } from '../errorReporting';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false };
    }

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error) {
        reportError(error, 'render');
    }

    render() {
        if (!this.state.failed) return this.props.children;
        return (
            <main className="text-page" role="alert">
                <h1>Something went wrong</h1>
                <p>
                    The page could not be shown. Your tournaments are safe. Reloading usually fixes it (a new version of the
                    app may be waiting).
                </p>
                <p>
                    <button className="btn btn-primary" onClick={() => window.location.reload()}>
                        Reload
                    </button>{' '}
                    <a className="btn" href="/">
                        Go to the start
                    </a>
                </p>
            </main>
        );
    }
}

export default ErrorBoundary;
